<template>
  <div class="linked-providers">
    <div 
      v-if="status.ready && providers" 
      class="grid-x grid-padding-x"
      :class="gridClasses">
      <div 
        v-for="(item, index) in providers" 
        :key="index" class="cell">
        <a href="#" @click.prevent="viewDetail(item)">
          <provider 
            :item="item"
            :orientation="config.orientation">
          </provider>
        </a>
      </div>
    </div>

  </div>
</template>

<script>
import Provider from '@/Provider.vue'
//import ProviderDetail from '@/ProviderDetail.vue'

export default {
  name: 'App',
  components: {
    Provider
  },
  data() {
    return {
      status: {
        ready: false,
        error: false
      },
      selectedItem: false,
      selected_id: 0,
      defaultModalWidth: 750,
      defaultModalHeight: 460
    }
  },
  methods: {
    beforeOpen (data) {
      this.selectedItem = data.params
    },
    viewDetail (item) {
      window.location = this.config.directory_url + '#/provider/' + item.id;
      /* console.log('view', item)
      this.$modal.show(
        ProviderDetail, { provider: item, height: 500 }, { 
          name: 'modal-provider-detail',
          width: this.modalWidth, 
          height: this.modalHeight 
        }
      ) */
    }
  },
  computed: {
    config () {
      return this.$options.config
    },
    gridClasses () {
      return [
        'small-up-' + this.config.items_per_row.small,
        'medium-up-' + this.config.items_per_row.medium,
        'large-up-' + this.config.items_per_row.large,
      ]
    },
    modalWidth () {
      const vp = this.$util.getViewport()
      if (window.matchMedia('(max-width: 640px)').matches) {
        return vp[0]
      } else {
        return this.defaultModalWidth
      }
    },
    modalHeight () {
      const vp = this.$util.getViewport()
      if (window.matchMedia('(max-width: 640px)').matches) {
        return vp[1]
      } else {
        return this.defaultModalHeight
      }
    },
    providers () {
      if (this.config) {
        return this.config.providers
      }
      return false
    }
  },
  mounted() {
    this.status.ready = true
  }
}
</script>

